module.exports = function isArray(x) {
  return x instanceof Array;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/isArray.js
 ** module id = 17
 ** module chunks = 0
 **/